import React, { useRef, useEffect } from 'react';

// ✅ 移到獨立文件，避免在 DashboardPage 每次 render 重新定義
const OptimizedImage = React.memo(({ src, alt, className, fallbackContent }) => {
  const imgRef = useRef(null);
  const observerRef = useRef(null);

  useEffect(() => {
    if (!imgRef.current || !src) return;

    // ✅ 移除不必要的 100ms 延遲
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && imgRef.current && src) {
          imgRef.current.src = src;
          observerRef.current?.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    observerRef.current.observe(imgRef.current);

    return () => {
      observerRef.current?.disconnect();
    };
  }, [src]);

  if (!src) return fallbackContent;

  return (
    <img
      ref={imgRef}
      alt={alt}
      className={className}
      loading="lazy"
      onError={(e) => { e.target.style.display = 'none'; }}
    />
  );
});

export default OptimizedImage;